import { Box, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Header } from 'Components/Header';
import { getAccessToken } from 'Features/slice/customer/customer.Slice';
import { useAppDispatch, useAppSelector } from 'Hooks/reduxHook';
import moment from 'moment';
import React, { useContext } from 'react'
import { Colors } from 'Utils/colors';
import { LocalImage } from 'Utils/images';
import { useState, useEffect } from 'react';
import { SnackBarContext } from "Context/SnackContext";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReactPaginate from "react-paginate";
import './PaginationStyling.css';
import { Invoices } from "Features/services/invoice.api";
import { useNavigate } from "react-router-dom";


const InvoiceDraftList = () => {

    const dispatch = useAppDispatch()
    const { access_token } = useAppSelector((state: any) => state.customer);
    const { handleSnackbar } = useContext(SnackBarContext);

    const navigate = useNavigate();

    const [rows, setRows] = useState<any>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

  const [currentPage, setCurrentPage] = useState<number>(1);


  useEffect(() => {
    dispatch(getAccessToken());
  }, [dispatch]);


  useEffect(() => {
    const fetchDraftList = async () => {
    
      try {
        setLoading(true);

        const payload = {
          access_token,
          maxResults: itemsPerPage,
          startPosition,
        };

        const response = await Invoices.instance.listDraftInvoice(payload)

        const result = response?.data?.data || [];
        setTotalCount(response?.data?.totalCount);
        setRows(result);
      } catch (error: any) {
        console.error("Error fetching data", error);
        handleSnackbar(true, `${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    };

    if (access_token) {
     fetchDraftList();
    }
  }, [access_token, currentPage]);


  const itemsPerPage = 10;
  const startPosition = (currentPage - 1) * itemsPerPage + 1;

  const handlePageClick = (event: { selected: number }) => {
    setCurrentPage(event.selected + 1);
  };

  const getDisplayedEntries = () => {

    if (totalCount === 0) return "0";
    const endPosition = Math.min(startPosition + itemsPerPage - 1, totalCount);
    return endPosition;
  }

  const handleViewClick = (draftData: any) => {
    navigate("/invoice/createInvoice", { state: { draftData } });
  };

  return (

    <Box
    component="main"
    sx={{
      backgroundImage: `url(${LocalImage.contactBg})`,
      backgroundRepeat: "no-repeat",
      backgroundColor: `${Colors.white}`,
      backgroundSize: "20% auto",
      backgroundPosition: "right bottom",
      flex: 1,
      overflow: "hidden",
      pl: 3,
      pr: 2,
      pt: 15,
      pb: 8,
    }}
  >
    <Header
      title={'Saved Drafts'}
      subTitle="You doing good, Keep it up!"
      btnName="New Invoice"
      onInputChange={() => {}}
      onButtonClick={() => navigate("/invoice/createInvoice")}
    />

    <Box sx={{ width: "100%" }} className="table-top-border"></Box>

    <Box sx={{ width: "100%" }}>
<Paper sx={{ width: "100%", mb: 2, boxShadow: "none" }}>
  <TableContainer sx={{ maxHeight: "60vh", overflowY: "auto" }}>
    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
      <TableHead>
        <TableRow>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Customer</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Email</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Status</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>City</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Country Code</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Produt</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5" }}>Created At</TableCell>
          <TableCell sx={{ backgroundColor: "#e6f1f5", textAlign: "center" }}>Actions</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={7} align="center">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bolder",
            height: "70vh",
          }}
        >
          <CircularProgress />
        </div>
      </TableCell>
    </TableRow>
  ) : (
    rows.map((row: any, index: number) => {
      const labelId = `enhanced-table-checkbox-${index}`;
      return (
        <TableRow
          hover
          tabIndex={-1}
          key={row.id}
          sx={{ cursor: "pointer" }}
        >
          <TableCell component="th" id={labelId} scope="row" align="left">
            {row.user_info.display_name}
          </TableCell>
          <TableCell align="left">{row.user_info.email}</TableCell>
          <TableCell align="left">{row.invoice_info.invoiceStatus || "N/A"}</TableCell>
          <TableCell align="left">{row.bill_addr.City}</TableCell>
          <TableCell align="left">{row.bill_addr.CountrySubDivisionCode}</TableCell>
          <TableCell align="left">{row.products[0].item}</TableCell>
          <TableCell align="left">
            {moment(row.created_at).format("h:mm a, Do MMMM YYYY")}
          </TableCell>
          
          <TableCell
            align="center">
            <IconButton
              size="small"
              style={{ color: "orange", cursor: "pointer" }}
              aria-label="view"
              onClick={() => handleViewClick(row)}
            >
              View
            </IconButton>
          </TableCell>

        </TableRow>
      );
    })
  )}
</TableBody>


    </Table>
  </TableContainer>

  {totalCount > 1 ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 3,
        px: 2,
      }}
    >
      <Typography
        variant="body1"
        component={"body"}
        color={"#717579"}
        fontSize={"14px"}
      >
        Showing {getDisplayedEntries()} from {totalCount} entries
      </Typography>

      <ReactPaginate
        previousLabel={<ArrowBackIosIcon sx={{ fontSize: "14px" }} />}
        nextLabel={<ArrowForwardIosIcon sx={{ fontSize: "14px" }} />}
        pageCount={Math.ceil(totalCount / itemsPerPage)}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName="active"
        forcePage={currentPage - 1}
        marginPagesDisplayed={0}
        pageRangeDisplayed={0}
      />
    </Box>
  ) : null}
</Paper>
</Box>
  

  </Box>
  )
}

export default InvoiceDraftList